var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.875 100.7L127.766 159.809L113.039 174.536L98.2617 159.809L73.6328 135.18L88.4102 120.403L113.039 145.032L172.098 85.9731L186.875 100.7Z",
    fill: "#FF204E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2734 135.332H9.14062C6.34766 135.332 4.0625 133.047 4.0625 130.254C4.0625 127.461 6.34766 125.176 9.14062 125.176H50.2734C53.0664 125.176 55.3516 127.461 55.3516 130.254C55.3516 133.047 53.0664 135.332 50.2734 135.332Z",
    fill: "url(#paint0_linear_599_1049)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.367 135.332H210.234C207.441 135.332 205.156 133.047 205.156 130.254C205.156 127.461 207.441 125.176 210.234 125.176H251.367C254.16 125.176 256.445 127.461 256.445 130.254C256.445 133.047 254.16 135.332 251.367 135.332Z",
    fill: "url(#paint1_linear_599_1049)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.255 55.3516C127.462 55.3516 125.177 53.0664 125.177 50.2734V9.14062C125.177 6.34766 127.462 4.0625 130.255 4.0625C133.048 4.0625 135.333 6.34766 135.333 9.14062V50.2734C135.333 53.0664 133.048 55.3516 130.255 55.3516Z",
    fill: "url(#paint2_linear_599_1049)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.255 256.75C127.462 256.75 125.177 254.465 125.177 251.672V210.234C125.177 207.441 127.462 205.156 130.255 205.156C133.048 205.156 135.333 207.441 135.333 210.234V251.672C135.333 254.465 133.048 256.75 130.255 256.75Z",
    fill: "url(#paint3_linear_599_1049)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.175 220.695C214.855 220.695 213.585 220.187 212.57 219.222L183.472 190.125C181.492 188.144 181.492 184.945 183.472 182.964C185.453 180.984 188.652 180.984 190.632 182.964L219.73 212.062C221.71 214.042 221.71 217.242 219.73 219.222C218.765 220.187 217.496 220.695 216.175 220.695Z",
    fill: "url(#paint4_linear_599_1049)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4521 218.817C41.1318 218.817 39.8623 218.309 38.8467 217.344C36.8662 215.364 36.8662 212.165 38.8467 210.184L67.9951 181.036C69.9756 179.055 73.1748 179.055 75.1553 181.036C77.1357 183.016 77.1357 186.215 75.1553 188.196L46.0576 217.344C45.042 218.309 43.7725 218.817 42.4521 218.817Z",
    fill: "url(#paint5_linear_599_1049)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.589 76.6289C183.269 76.6289 182 76.1211 180.984 75.1563C179.003 73.1758 179.003 69.9766 180.984 67.9961L210.082 38.9492C212.062 36.9688 215.261 36.9688 217.242 38.9492C219.222 40.9297 219.222 44.1289 217.242 46.1094L188.195 75.1563C187.179 76.1211 185.91 76.6289 184.589 76.6289Z",
    fill: "url(#paint6_linear_599_1049)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5806 78.8633C72.2603 78.8633 70.9907 78.3555 69.9751 77.3906L40.9282 48.3437C38.9478 46.3633 38.9478 43.1641 40.9282 41.1836C42.9087 39.2031 46.1079 39.2031 48.0884 41.1836L77.1353 70.2305C79.1157 72.2109 79.1157 75.4102 77.1353 77.3906C76.1704 78.3555 74.9009 78.8633 73.5806 78.8633Z",
    fill: "url(#paint7_linear_599_1049)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.039 61.242C98.0082 61.242 96.1293 60.0233 95.3168 58.0428L87.6489 38.7967C86.6332 36.2069 87.9028 33.2616 90.4926 32.1952C93.0825 31.1795 96.0278 32.4491 97.0942 35.0389L104.762 54.285C105.778 56.8749 104.508 59.8202 101.918 60.8866C101.309 61.1405 100.649 61.242 100.039 61.242ZM55.809 106.031C55.1996 106.031 54.5903 105.93 54.0317 105.726L36.8676 99.2772C34.227 98.3124 32.9067 95.367 33.9223 92.7264C34.8872 90.0858 37.8325 88.7655 40.4731 89.7811L57.6371 96.2303C60.2778 97.1952 61.5981 100.14 60.5825 102.781C59.8207 104.762 57.8403 106.031 55.809 106.031ZM38.645 174.637C36.9184 174.637 35.1918 173.723 34.2778 172.098C32.8559 169.66 33.6684 166.562 36.1059 165.14L53.27 155.137C55.7075 153.715 58.8051 154.527 60.227 156.965C61.6489 159.402 60.8364 162.5 58.3989 163.922L41.2348 173.926C40.4223 174.433 39.5082 174.637 38.645 174.637ZM89.1215 226.433C88.4614 226.433 87.852 226.332 87.1918 226.078C84.602 225.012 83.3325 222.066 84.3989 219.476L91.9653 200.992C93.0317 198.402 95.977 197.133 98.5668 198.199C101.157 199.265 102.426 202.211 101.36 204.801L93.7934 223.285C93.0317 225.265 91.102 226.433 89.1215 226.433ZM171.844 226.433C169.864 226.433 168.036 225.265 167.172 223.387L159.149 204.902C158.032 202.312 159.2 199.316 161.789 198.199C164.379 197.082 167.375 198.25 168.493 200.84L176.516 219.324C177.633 221.914 176.465 224.91 173.875 226.027C173.215 226.281 172.504 226.433 171.844 226.433ZM221.153 171.742C220.493 171.742 219.782 171.59 219.122 171.336L202.668 164.226C200.079 163.109 198.911 160.113 200.028 157.574C201.145 154.984 204.141 153.816 206.68 154.933L223.133 162.043C225.723 163.16 226.891 166.156 225.774 168.695C224.961 170.574 223.133 171.742 221.153 171.742ZM203.329 102.832C201.399 102.832 199.52 101.715 198.657 99.785C197.539 97.1952 198.707 94.1991 201.247 93.0819L219.071 85.2108C221.661 84.0936 224.657 85.2616 225.774 87.8006C226.891 90.3905 225.723 93.3866 223.184 94.5038L205.36 102.375C204.7 102.68 204.039 102.832 203.329 102.832ZM162.45 62.1053C161.993 62.1053 161.485 62.0545 161.028 61.9022C158.336 61.0897 156.813 58.2967 157.575 55.6053L163.516 35.4959C164.329 32.8045 167.122 31.2811 169.813 32.0428C172.504 32.8553 174.028 35.6483 173.266 38.3397L167.325 58.4491C166.664 60.6834 164.633 62.1053 162.45 62.1053Z",
    fill: "#EA3939"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_599_1049",
    x1: 4.0625,
    y1: 130.254,
    x2: 55.3516,
    y2: 130.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_599_1049",
    x1: 205.156,
    y1: 130.254,
    x2: 256.445,
    y2: 130.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_599_1049",
    x1: 125.177,
    y1: 29.707,
    x2: 135.333,
    y2: 29.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_599_1049",
    x1: 125.177,
    y1: 230.953,
    x2: 135.333,
    y2: 230.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_599_1049",
    x1: 181.987,
    y1: 201.087,
    x2: 221.215,
    y2: 201.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_599_1049",
    x1: 37.3613,
    y1: 199.183,
    x2: 76.6406,
    y2: 199.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_599_1049",
    x1: 179.499,
    y1: 57.0461,
    x2: 218.727,
    y2: 57.0461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_599_1049",
    x1: 39.4429,
    y1: 59.281,
    x2: 78.6206,
    y2: 59.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2FC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.44eb1d986bc441b745d4f62820fa85f8.svg";
export { ForwardRef as ReactComponent };